import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetAquacultureQuery,
  usePublicGetAquacultureQuery,
  useGetAquacultureDefaultsQuery,
  usePublicGetAquacultureDefaultsQuery,
  useUpdateAquacultureMutation
} from '../features/modules/aquacultureApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting aquaculture data based on the current route.
 */
export const useContextAwareGetAquaculture = createContextAwareHook(
  useGetAquacultureQuery,
  usePublicGetAquacultureQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting aquaculture defaults based on the current route.
 */
export const useContextAwareGetAquacultureDefaults = createContextAwareHook(
  useGetAquacultureDefaultsQuery,
  usePublicGetAquacultureDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateAquacultureMutation
}; 